import { useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";

import { Authorization, useAuthorization } from "../../common/AuthorizationCpt";
import { PaymentPaidResource } from "./Paid/PaymentPaidResource";
import { PaymentHeader } from "./PaymentStyles";
import { PaymentPendingResource } from "./Pending/PaymentPendingResource";
import { PaymentQuotedResource } from "./Quoted/PaymentQuotedResource";

const BILLING_PAYMENT_OPTIONS = {
  payment: {
    screenName: "Pagos",
    path: "/web/importaciones/facturacion/pagos",
    authorization: [
      "quotation.get_quotation_quoted",
      "quotation.get_quotation_pending",
      "quotation.get_quotation_paid_intranet",
    ],
    children: {
      quoted: {
        screenName: "Prefacturas",
        path: "/web/importaciones/facturacion/pagos/prefacturas",
        authorization: ["quotation.get_quotation_quoted"],
        component: function Quoted() {
          return <PaymentQuotedResource />;
        },
      },
      pending: {
        screenName: "Estado de validación",
        path: "/web/importaciones/facturacion/pagos/estadoValidaciones",
        authorization: ["quotation.get_quotation_pending"],
        component: function Pending() {
          return <PaymentPendingResource />;
        },
      },
      paid: {
        screenName: "Facturado",
        path: "/web/importaciones/facturacion/pagos/facturados",
        authorization: ["quotation.get_quotation_paid_intranet"],
        component: function Paid() {
          return <PaymentPaidResource />;
        },
      },
    },
  },
};

function Payment() {
  const [quotationType, updateQuotationType] = useState<any>();

  const authorization = useAuthorization();

  const [options] = useState(() => {
    const options = Object.keys(BILLING_PAYMENT_OPTIONS.payment.children)
      .map((key) => BILLING_PAYMENT_OPTIONS.payment.children[key])
      .filter((option) => {
        return authorization.isAllowedByActions(option.authorization);
      });
    return options;
  });

  const history = useHistory();
  useEffect(() => {
    if (history.location.pathname === BILLING_PAYMENT_OPTIONS.payment.path) {
      const first = options[0];
      if (first) {
        history.push(first.path);
      } else {
        history.push("/web");
      }
    }
  }, [history, options, history.location.pathname]);

  useEffect(() => {
    const getQuotationType = (pathname) => {
      const { paid, pending, quoted } =
        BILLING_PAYMENT_OPTIONS.payment.children;

      if (pathname.startsWith(quoted.path)) return 0;
      if (pathname.startsWith(pending.path)) return 1;
      if (pathname.startsWith(paid.path)) return 2;
    };

    const unsub = history.listen((location) => {
      const pathname = location.pathname;
      const quotationType = getQuotationType(pathname);
      updateQuotationType(quotationType);
    });

    const pathname = history.location.pathname;
    const quotationType = getQuotationType(pathname);
    updateQuotationType(quotationType);

    return () => {
      unsub();
    };
  }, [history]);

  return (
    <div>
      <PaymentHeader>
        <h2>PAGO DE FACTURACIÓN</h2>
        <div className="payment-tabs">
          {options.map((option, i) => {
            return (
              <Authorization key={i} actions={option.authorization}>
                <div
                  className="quotations tab-name"
                  onClick={() => {
                    history.push(option.path);
                  }}
                  style={{
                    borderBottomStyle: i === quotationType ? "solid" : "none",
                    borderColor: "#0e1944",
                  }}
                >
                  {option.screenName}
                </div>
              </Authorization>
            );
          })}
        </div>
      </PaymentHeader>
      {options.map((option, i) => {
        return (
          <Route key={i} path={option.path}>
            <Authorization actions={option.authorization}>
              {option.component()}
            </Authorization>
          </Route>
        );
      })}
    </div>
  );
}

export default Payment;
